<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import reviewsLogo from './images/reviewsio-logo.svg';
	import Rating from './Rating.svelte';

	let { title, rating, average, total } = $props();
</script>

<div class="content-grid">
	<!-- eslint-disable better-tailwindcss/no-unknown-classes -->
	<div
		class="
    bubble-arrow relative mb-10 w-full rounded-lg bg-indow-white px-4 py-5
    text-indow-grey-dark
  "
	>
		<!-- eslint-enable better-tailwindcss/no-unknown-classes -->
		<div
			class="flex w-full flex-row flex-wrap items-center justify-between gap-8"
		>
			<div class="grow">
				<div
					class="
       flex flex-col gap-2
       sm:flex-row sm:items-center
     "
				>
					<h3
						class="
        m-0 w-auto p-0 text-left text-xl font-normal text-indow-grey-dark
        uppercase
      "
					>
						{title}
					</h3>
					<Rating stars="5" {rating} hideMetaData />
				</div>
				<div class="mt-2 flex flex-row gap-3 text-indow-grey-dark">
					<p class="m-0 w-auto text-left">
						{average}
						<span class="text-indow-grey">Average</span>
						<span class="sr-only relative text-indow-grey">Rating</span>
					</p>
					<p class="m-0 w-auto text-left">
						{total}
						<span class="text-indow-grey!">Reviews</span>
					</p>
				</div>
			</div>
			<div class="grow text-end">
				<a
					href="https://www.reviews.io/company-reviews/store/indow1?utm_source=indow1&utm_medium=widget&utm_campaign=carousel"
					target="_blank"
					rel="noreferrer"
					class="inline-block w-full max-w-44"
				>
					<Image src={reviewsLogo} alt="Reviews.io logo" loading="lazy" />
				</a>
			</div>
		</div>
	</div>
</div>

<style>
	.bubble-arrow::after {
		content: '';

		position: absolute;
		bottom: -1rem;
		left: 0;
		transform: translateX(-50%);
		margin-left: 50%;
		width: 0;
		height: 0;
		border-left: 0.75rem solid transparent;
		border-right: 0.75rem solid transparent;
		border-top: 1rem solid white;
	}
</style>
